import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanTransform'
})
export class BooleanTransformPipe implements PipeTransform {

  transform(value: any): string {
    if(value == null){
      return '';
    }
    return value ? 'Si' : 'No';
  }

}
